module.exports = __webpack_public_path__ + "img/header-papeis.b490a502.png";